import { PayloadAction, createSlice } from "@reduxjs/toolkit";

const initialState = {
  isEditingForm: false,
  isFromNormalFlow: false,
};

const preconfirmationReducer = createSlice({
  name: "preconfirmation",
  initialState,
  reducers: {
    onUpdatePreconfirmation: (state, action: PayloadAction<boolean>) => {
      state.isEditingForm = action.payload;
    },
    onUpdateIsFromNormalFlow: (state, action: PayloadAction<boolean>) => {
      state.isFromNormalFlow = action.payload;
    },
  },
});

export const { onUpdatePreconfirmation, onUpdateIsFromNormalFlow } =
  preconfirmationReducer.actions;

export default preconfirmationReducer.reducer;
